module.exports = __webpack_public_path__ + "img/6.33f915a1.svg";